import { defineComponent as _defineComponent } from 'vue'
import {
    PropType,
    ref,
    watch,
    nextTick,
    reactive,
    computed,
  } from "vue";
  import ModalWithHeader from "../ModalWithHeader.vue";
  import { InclusionInterface } from "@/types/InclusionInterface";
  import { capitalizeFirstLetter } from "@/components/builder/gallery/capitalizeFirstLetter";
  import { close } from "@sentry/vue";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'InclusionDetailModal',
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    inclusion: {
      type: Object as PropType<InclusionInterface>,
      required: true,
    },
  },
  emits: ["close", "deleteInclusion", "openAddModal"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;

  const isEditModalOpen = ref(false);
  const selectedInclusion = reactive({ name: "", description: [""] });

  const emits = __emit;

  const openEditModal = (index: number) => {
    Object.assign(selectedInclusion, props.inclusion.inclusions[index]);
    isEditModalOpen.value = true;
  };

  const handleCloseEditModal = () => {
    isEditModalOpen.value = false;
  };

  const closeModal = () => {
    emits("close");
  };

  const deleteInclusion = () => {
    emits("deleteInclusion", props.inclusion);
  };

const __returned__ = { props, isEditModalOpen, selectedInclusion, emits, openEditModal, handleCloseEditModal, closeModal, deleteInclusion, PropType, ref, watch, nextTick, reactive, computed, ModalWithHeader, get InclusionInterface() { return InclusionInterface }, get capitalizeFirstLetter() { return capitalizeFirstLetter }, get close() { return close } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})